import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Construction = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.305 7.01c0-.5.4-.9.9-.9h9.59c.5 0 .9.4.9.9v13.092c0 1.199-1.799 1.199-1.799 0V7.909h-7.892v12.193c0 1.199-1.799 1.199-1.799 0V7.01h.1Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.683 29.895v-3.398c0-6.895-3.797-12.891-9.292-16.19-.4-.2-.999-.1-1.199.3-.2.4-.1 1 .3 1.2 4.995 2.898 8.392 8.394 8.392 14.59v3.398H5.116v-3.397c0-6.197 3.397-11.693 8.392-14.591.4-.2.6-.8.3-1.2-.2-.4-.8-.6-1.2-.3-5.594 3.199-9.29 9.195-9.29 16.19v3.398c-4.696.6-4.297 7.995.499 7.995h36.366c4.796 0 5.195-7.395.5-7.995Zm-.5 1.8c1.299 0 2.198 1.199 1.998 2.398 0 1.099-.899 1.998-1.998 1.998H3.817c-1.099 0-1.998-.899-1.998-1.998-.2-1.2.7-2.499 1.998-2.499h36.366v.1Z"
  }));
});
Construction.displayName = 'Construction';
Construction.defaultProps = {
  'aria-label': 'Construction'
};
export default Construction;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Subject/Construction.js
// module id = 2999
// module chunks = 11